/**
 * Инициализация выбиратора.
 */
function main(): void
{
	const path = window.location.pathname;
	
	if ( /^\/choose\/apartment\/?$/.test( path ) )
	{
		import ( /* webpackChunkName: "choose-apartment" */ './Index/index' )
			.then( ( module ) => module.default() );
	}
	else
	{
		import ( /* webpackChunkName: "choose-card" */ './Card/index' )
			.then( ( module ) => module.default() );
	}
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/index.ts